import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { FAMILY_PROFILE_UUID_STORAGE_KEY } from '~/core/constants/sessionStorage';
import { isDeeplinkOnlyPage } from '~/core/functions';
import useMainStore from '~/stores/useMainStore';
import useMedcardStore from '~/stores/useMedcardStore';
import showError from '~/bridge/showError';
export default defineNuxtRouteMiddleware(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
    var mainStore, medcardStore, _useNuxtApp, $device, $sentry, $captureException, _to$name, _to$meta, meta, _to$name2, _from$name, _to$name3, uuid, sessionStorageUuid;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mainStore = useMainStore();
          medcardStore = useMedcardStore();
          _useNuxtApp = useNuxtApp(), $device = _useNuxtApp.$device, $sentry = _useNuxtApp.$sentry, $captureException = _useNuxtApp.$captureException;
          _context.prev = 3;
          if (!((_to$name = to.name) !== null && _to$name !== void 0 && _to$name.includes('dental-articles') || isDeeplinkOnlyPage(to, $device, $sentry))) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          meta = ((_to$meta = to.meta) === null || _to$meta === void 0 ? void 0 : _to$meta[0]) || {}; // NOTE: Используется для обновления информации о семейных профилях для определенных роутов
          if (!meta.useFamily) {
            _context.next = 13;
            break;
          }
          _context.next = 10;
          return mainStore.fetchFamily((_to$name2 = to.name) === null || _to$name2 === void 0 ? void 0 : _to$name2.includes('profile'));
        case 10:
          uuid = to.query.uuid;
          sessionStorageUuid = sessionStorage.getItem(FAMILY_PROFILE_UUID_STORAGE_KEY);
          if (uuid && mainStore.family.find(function (member) {
            return member.uuid === uuid;
          })) {
            medcardStore.setFamilyProfileUuid(uuid);
          } else if (!((_from$name = from.name) !== null && _from$name !== void 0 && _from$name.includes('medcard')) || !((_to$name3 = to.name) !== null && _to$name3 !== void 0 && _to$name3.includes('medcard')) || !sessionStorageUuid || !mainStore.family.find(function (member) {
            return member.uuid === sessionStorageUuid;
          })) {
            medcardStore.setFamilyProfileUuid(mainStore.family.find(function (member) {
              return member.isMain;
            }).uuid);
          }
        case 13:
          _context.next = 19;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);
          $captureException(_context.t0, {
            message: 'Ошибка при запросе семейных профилей'
          });
          showError(_context.t0);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 15]]);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());